import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { categoriesStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsCategories";
import { productLinesStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsProductLines";
import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion";
import { AccordionSectionPresentationProps, ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LazyImage from "@insite/mobius/LazyImage/LazyImage";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import Radio from "@insite/mobius/Radio";
import RadioGroup from "@insite/mobius/RadioGroup";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    heading = "heading",
    uploadFile = "uploadFile",
    fileTitle = "fileTitle",
    initialExpandedFlag = "initialExpandedFlag",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.heading]: string;
        [fields.uploadFile]: string;
        [fields.fileTitle]: string;
        [fields.initialExpandedFlag]: boolean;
    };
}
type Props = OwnProps;

export interface CommonCustomContainerStyles {
    messagesAccordionSection?: AccordionSectionPresentationProps;
    container?: InjectableCss;
    innerContainer?: InjectableCss;
    messagesGridContainer?: GridContainerProps;
    messagesAccordion?: AccordionPresentationProps;
    messageFilterGridItem?: GridItemProps;
}

export const CommonCustomContainerStyles: CommonCustomContainerStyles = {
    container: {
        css: css`
            padding: 0 0 20px 0;
            > dl > dt > button {
                border: 0px solid #cccccc;
                border-bottom: 3px solid rgb(239, 55, 66);
                &:focus {
                    outline: none;
                    border-style: solid;
                    border-width: 0px;
                    border-color: rgb(239, 55, 66);
                    border-bottom: 3px solid rgb(239, 55, 66);
                    padding: 9px;
                    padding-left: 15px;
                }
            }
            dd[data-test-selector^="sectionPanel"] {
                border: 0px solid #cccccc;
            }
        `,
    },
    messagesAccordion: {
        css: css`
            width: 100%;
        `,
    },
    innerContainer: {
        css: css`
            display: flex;
            align-items: center;
            > div:first-child {
                margin: 0 10px 0 0;
            }
        `,
    },
    messagesGridContainer: { gap: 15 },
    messageFilterGridItem: { width: 12 },
};

const styles = CommonCustomContainerStyles;

const CustomAccordian: React.FC<Props> = ({ id, fields }) => {
    const [isPreview, setState] = React.useState(false);
    return (
        <StyledWrapper {...styles.container} data-test-selector="CommonCustomWrapper">
            <Accordion {...styles.messagesAccordion} headingLevel={2}>
                <ManagedAccordionSection
                    title={fields.heading}
                    onTogglePanel={() => {
                        setState(!isPreview);
                    }}
                    {...styles.messagesAccordionSection}
                    initialExpanded={fields.initialExpandedFlag}
                >
                    <GridContainer {...styles.messagesGridContainer}>
                        <GridItem {...styles.messageFilterGridItem}>
                            <Zone contentId={id} zoneName="Content1" />
                        </GridItem>
                    </GridContainer>
                </ManagedAccordionSection>
            </Accordion>
        </StyledWrapper>
    );
};
const definition: WidgetDefinition = {
    group: "Common",
    fieldDefinitions: [
        {
            name: fields.heading,
            displayName: "Heading",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "text tip",
            placeholder: "Enter Title",
        },
        {
            name: fields.initialExpandedFlag,
            displayName: "Initially Expand",
            editorTemplate: "CheckboxField",
            defaultValue: false,
            fieldType: "General",
        },
    ],
};

const widgetModule: WidgetModule = {
    component: CustomAccordian,
    definition,
};

export default widgetModule;
